// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CommonFields-errorMessage-Ln8r7 {
  margin: 5px 0px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
}


.CommonFields-displayGrid-q0_oX {
    display: grid;
    grid-template-columns: 1fr 1fr;
    -webkit-column-gap: 20px;
       -moz-column-gap: 20px;
            column-gap: 20px;
}


.CommonFields-birthDayFlex-zTFPL {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    -webkit-column-gap: 20px;
       -moz-column-gap: 20px;
            column-gap: 20px;
}


.CommonFields-noMarginBottom-qjBji {
    margin-bottom: 0px;
}


.CommonFields-editMainContainer-LOthr {
    padding: 24px 15px;
    border-radius: 6px;
    border: 1px solid var(--primary-border);
}


.CommonFields-phoneNoInputFlex-NdYt7 {
    padding: 15px;
    border: 1px solid var(--primary-border);
    border-radius: 6px;
    margin-bottom: 15px;
}


.CommonFields-editLabel-gWeHN {
    display: inline-block;
    max-width: 100%;
    margin-top: 0px !important;
    margin-bottom: 5px !important;
    font-weight: 700 !important;
    font-size: 14px !important;
}


@media screen and (max-width: 767px) {

    .CommonFields-birthDayFlex-zTFPL,
    .CommonFields-displayGrid-q0_oX {
        grid-template-columns: 100%;
        gap: 0;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/utils.css","webpack://./src/components/CommonFields/CommonFields.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;;;ACHA;IACI,aAAa;IACb,8BAA8B;IAC9B,wBAAgB;OAAhB,qBAAgB;YAAhB,gBAAgB;AACpB;;;AAEA;IACI,aAAa;IACb,kCAAkC;IAClC,wBAAgB;OAAhB,qBAAgB;YAAhB,gBAAgB;AACpB;;;AAGA;IACI,kBAAkB;AACtB;;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,uCAAuC;AAC3C;;;AAEA;IACI,aAAa;IACb,uCAAuC;IACvC,kBAAkB;IAClB,mBAAmB;AACvB;;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,0BAA0B;IAC1B,6BAA6B;IAC7B,2BAA2B;IAC3B,0BAA0B;AAC9B;;;AAEA;;IAEI;;QAEI,2BAA2B;QAC3B,MAAM;IACV;AACJ","sourcesContent":[".errorMessage {\n  margin: 5px 0px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n}","@import '../../components/utils.css';\n\n\n.displayGrid {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    column-gap: 20px;\n}\n\n.birthDayFlex {\n    display: grid;\n    grid-template-columns: 1fr 1fr 1fr;\n    column-gap: 20px;\n}\n\n\n.noMarginBottom {\n    margin-bottom: 0px;\n}\n\n.editMainContainer {\n    padding: 24px 15px;\n    border-radius: 6px;\n    border: 1px solid var(--primary-border);\n}\n\n.phoneNoInputFlex {\n    padding: 15px;\n    border: 1px solid var(--primary-border);\n    border-radius: 6px;\n    margin-bottom: 15px;\n}\n\n.editLabel {\n    display: inline-block;\n    max-width: 100%;\n    margin-top: 0px !important;\n    margin-bottom: 5px !important;\n    font-weight: 700 !important;\n    font-size: 14px !important;\n}\n\n@media screen and (max-width: 767px) {\n\n    .birthDayFlex,\n    .displayGrid {\n        grid-template-columns: 100%;\n        gap: 0;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorMessage": `CommonFields-errorMessage-Ln8r7`,
	"displayGrid": `CommonFields-displayGrid-q0_oX`,
	"birthDayFlex": `CommonFields-birthDayFlex-zTFPL`,
	"noMarginBottom": `CommonFields-noMarginBottom-qjBji`,
	"editMainContainer": `CommonFields-editMainContainer-LOthr`,
	"phoneNoInputFlex": `CommonFields-phoneNoInputFlex-NdYt7`,
	"editLabel": `CommonFields-editLabel-gWeHN`
};
module.exports = ___CSS_LOADER_EXPORT___;
